
import React from 'react';
import { Globe, TrendingUp, Users, Truck, Shield, BarChart3 } from 'lucide-react';
import TranslatedText from '@/TranslatedText';

const benefits = [
  {
    icon: <TrendingUp className="h-6 w-6 text-ahavex-gold" />,
    title: 'Increased Reach',
    description: 'Expand your customer base across Rwanda and neighboring countries through our established network.'
  },
  {
    icon: <Truck className="h-6 w-6 text-ahavex-gold" />,
    title: 'Simplified Logistics',
    description: 'We handle product storage, delivery, and distribution, letting you focus on creating great products.'
  },
  {
    icon: <BarChart3 className="h-6 w-6 text-ahavex-gold" />,
    title: 'Data Insights',
    description: 'Get valuable market insights and analytics to understand your customers better.'
  },
  {
    icon: <Users className="h-6 w-6 text-ahavex-gold" />,
    title: 'Marketing Support',
    description: 'Benefit from our marketing efforts, including seasonal promotions and special campaigns.'
  },
  {
    icon: <Shield className="h-6 w-6 text-ahavex-gold" />,
    title: 'Secure Payments',
    description: 'Receive timely and secure payments with transparent transaction records.'
  },
  {
    icon: <Globe className="h-6 w-6 text-ahavex-gold" />,
    title: 'Market Expansion',
    description: 'Opportunity to expand into new markets as we grow our presence across Africa.'
  }
];

const BenefitsSection: React.FC = () => {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-ahavex-blue mb-4">
            <TranslatedText text="Benefits of Selling with Ahavex" />
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            <TranslatedText 
              text="As your strategic partner, we offer numerous advantages to help scale your business"
            />
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-6 hover:border-ahavex-gold transition-colors">
              <div className="bg-blue-50 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3">
                <TranslatedText text={benefit.title} />
              </h3>
              <p className="text-gray-600">
                <TranslatedText text={benefit.description} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
